import { AuthUser as OidcUser } from '@modules/auth/models/user-oidc';
import { PlatformMode } from './platform-mode.model';

export interface UserDataInfo {
    user: OidcUser | null;
    userId: string | null;
    username: string | null;
    clientId: string | null;
    subject: string | null;
    clientName: string | null;
    clientDisplayName: string | null;
    clientSlug: string | null;
    clientLogo: string | null;
    clientColor: string | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    platformMode: PlatformMode | null;
    roles: string[];
    accessToken: string | null;
    refreshToken: string | null;
    tokenExpiry: number | null;
    dateLoggedIn: number | null;
    isLoading: boolean;
    error: string | null;
}

export const initialState: UserDataInfo = {
    user: null,
    userId: null,
    username: null,
    clientId: null,
    subject: null,
    clientName: null,
    clientDisplayName: null,
    clientSlug: null,
    clientLogo: null,
    clientColor: null,
    firstName: null,
    lastName: null,
    email: null,
    platformMode: null,
    roles: [],
    accessToken: null,
    refreshToken: null,
    tokenExpiry: null,
    dateLoggedIn: null,
    isLoading: false,
    error: null,
};
